export default __webpack_public_path__ + "static/src/companys/fubon/assets/images/icons/market_comment_add.png";